import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/visita-domiciliar`

    return {
        index(params) {
            return repository.get(`${baseUrl}`, params)
        },
        getAtendimentos(params) {
            return repository.get(`${baseUrl}/atendimento?${urlUtil.serialize(params)}`)
        },
        updateTelefone(params) {
            return repository.put(`${baseUrl}/telefone`, params)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        datatable(queryParams) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParams)}`)
        },
        getUnidades(queryParms) {

            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        getEquipes(queryParms) {

            return repository.get(`${baseUrl}/equipe?${urlUtil.serialize(queryParms)}`)
        },
        getInfraestruturas(queryParms) {

            return repository.get(`${baseUrl}/infraestrutura?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoes(queryParms) {

            return repository.get(`${baseUrl}/ocupacao?${urlUtil.serialize(queryParms)}`)
        },
        getResidentes(queryParms) {

            return repository.get(`${baseUrl}/residente?${urlUtil.serialize(queryParms)}`)
        },
        getOcupacoesAuxiliar(queryParms) {

            return repository.get(`${baseUrl}/ocupacao-auxiliar?${urlUtil.serialize(queryParms)}`)
        },
        getProcedimentosAgendados(queryParms) {

            return repository.get(`${baseUrl}/procedimento-agendado?${urlUtil.serialize(queryParms)}`)
        },
        comunidade: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-comunidade?${urlUtil.serialize(queryParms)}`)
            },
        },
        getVisitaDomiciliarForHistorico(id) {
            return repository.get(`${baseUrl}/historico-visita-domiciliar/${id}`)
        },
    }
}